<div class="badge" [ngClass]="(custom)?'custom':''">
    {{labelText}}
</div>
